<template>
  <div class="messages">
    <div v-if="!subscribed">
      <article v-if="newTrial" class="bg-warning text-white">
        <i class="fa fa-exclamation-triangle"></i>
        <div>You have not yet activated your free trial. All listings are paused. <b-link to="/account" class="text-white">Click here</b-link> to activate it now and start posting!</div>
        <b-button to="/account" class="action-btn" variant="primary">Fix Now</b-button>
      </article>
      <article v-else-if="trialDays > 0" class="bg-warning text-white">
        <i class="fa fa-exclamation-triangle"></i>
        <div>You have previously cancelled your trial plan. All listings are paused. <b-link to="/account" class="text-white">Click here</b-link> to re-activate it now and start posting!</div>
        <b-button to="/account" class="action-btn" variant="primary">Fix Now</b-button>
      </article>
      <article v-else class="bg-danger text-white">
        <i class="fa fa-exclamation-triangle"></i>
        <div>Your subscription <strong>has expired</strong>. All listings are paused. <b-link to="/account" class="text-white">Click here</b-link> to re-activate it now and start posting!</div>
        <b-button to="/account" class="action-btn" variant="primary">Fix Now</b-button>
      </article>
    </div>
    <article v-for="(message, idx) in custom" :key="idx" :class="`bg-${message.type} text-white`">
      <i class="fa fa-exclamation-triangle"></i>
      <div v-html="message.text"></div>
      <b-button v-if="typeof message.action === 'function'" @click="message.action" class="action-btn" variant="primary">{{message.actionText}}</b-button>
    </article>
  </div>
</template>

<script>
import EventBus from "../shared/event-bus";
import uuid from 'uuid/v1';

export default {
  name: "Messages",

  data() {
    return {
      newTrial: this.$session.get("account.newTrial"),
      trialDays: this.$session.get("account.trialDays"),
      subscribed: this.$session.get("account.subscribed"),

      custom: []
    };
  },

  mounted() {
    EventBus.$on("session.token", this.tokenChanged.bind(this));
    EventBus.$on("messages.show", this.showMessage.bind(this));
    EventBus.$on("messages.hide", this.hideMessage.bind(this));
  },

  methods: {
    tokenChanged() {
      this.newTrial = this.$session.get("account.newTrial");
      this.trialDays = this.$session.get("account.trialDays");
      this.subscribed = this.$session.get("account.subscribed");
    },

    showMessage([text, type = 'danger', action = () => {}, actionText = 'Fix Now'], cb = () => {}){
      let message = { id: uuid(), text, type, action, actionText }

      this.custom.push(message);
      cb(message)
    },

    hideMessage(id){
      this.custom = this.custom.filter((msg) => msg.id !== id)
    }
  }
};
</script>
